module.exports = __webpack_public_path__ + "img/studiosha.79dcdae1.png";